import React, { useMemo, useState } from "react";

// Formatos
function fmtUSD(n) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(Number(n) || 0);
}

// Helper: primer valor no null/undefined
function pick() {
  for (var i = 0; i < arguments.length; i++) {
    var v = arguments[i];
    if (v !== undefined && v !== null) return v;
  }
  return undefined;
}

// Agrupa filas planas -> { salesPerson -> { totals, categories -> { totals, clients{} } } }
function buildHierarchy(rows) {
  var out = {};
  rows = Array.isArray(rows) ? rows : [];

  // console.log(rows[0]);

  for (var i = 0; i < rows.length; i++) {
    var r = rows[i] || {};

    var salesPerson = r.SalesPerson ? String(r.SalesPerson) : (r.salesPerson ? String(r.salesPerson) : "NA");
    var lob = r.ProductLineDesc ? String(r.ProductLineDesc) : (r.lob ? String(r.lob) : "SIN_CATEGORIA");
    var client = r.BillToName ? String(r.BillToName) : (r.CustomerName ? String(r.CustomerName) : (r.client ? String(r.client) : "Unknown"));

    var facturado = Number(pick(r.Facturado, r.facturado, r.count, 0) || 0);
    var freight = Number(pick(r.FleteCobrado, r.freight, r.FletesCarrier, 0) || 0);
    var facturaCarrier = Number(pick(r.FacturaCarrier, r.carrier_price, r.fcarrier, 0) || 0);
    var subCantidad = Number(pick(r.SubsidioCantidad, r.subCantidad, r.scantidad, 0) || 0);
    var subPorcentaje = Number(pick(r.SubsidioProcentaje, r.subPorcentaje, r.subporcentaje, 0) || 0);
    var subsidyDiff = facturaCarrier && freight ? facturaCarrier - freight : 0;

    if (!out[salesPerson]) {
      out[salesPerson] = { totals: { facturado: 0, freight: 0, subsidyDiff: 0, facturaCarrier: 0, subCantidad: 0, subPorcentaje: 0, diffAgg: 0, diffCount: 0 }, categories: {} };
    }
    if (!out[salesPerson].categories[lob]) {
      out[salesPerson].categories[lob] = { totals: { facturado: 0, freight: 0, subsidyDiff: 0, facturaCarrier: 0, subCantidad: 0, subPorcentaje: 0,  diffAgg: 0, diffCount: 0 }, clients: {} };
    }
    if (!out[salesPerson].categories[lob].clients[client]) {
      out[salesPerson].categories[lob].clients[client] = { facturado: 0, freight: 0, subsidyDiff: 0, facturaCarrier: 0, subCantidad: 0, subPorcentaje: 0,  diffAgg: 0, diffCount: 0 };
    }

    // Cliente
    var c = out[salesPerson].categories[lob].clients[client];
    c.facturado += facturado;
    c.freight += freight;
    c.facturaCarrier += facturaCarrier;
    c.subsidyDiff += subsidyDiff;
    c.subCantidad += subCantidad;
    c.subPorcentaje += subPorcentaje;
    c.diffAgg += facturaCarrier;
    c.diffCount += 1;

    // Categoría
    var cat = out[salesPerson].categories[lob].totals;
    cat.facturado += facturado;
    cat.freight += freight;
    cat.facturaCarrier += facturaCarrier;
    cat.subsidyDiff += subsidyDiff;
    cat.subCantidad += subCantidad;
    cat.subPorcentaje += subPorcentaje;
    cat.diffAgg += facturaCarrier;
    cat.diffCount += 1;

    // Estado
    var st = out[salesPerson].totals;
    st.facturado += facturado;
    st.freight += freight;
    st.facturaCarrier += facturaCarrier;
    st.subsidyDiff += subsidyDiff;
    st.subCantidad += subCantidad;
    st.subPorcentaje += subPorcentaje;
    st.diffAgg += facturaCarrier;
    st.diffCount += 1;
  }

  // A arreglos ordenados
  var states = Object.keys(out).sort();
  var result = states.map(function (stKey) {
    var st = out[stKey];
    var catsKeys = Object.keys(st.categories).sort();
    var cats = catsKeys.map(function (cKey) {
      var cat = st.categories[cKey];
      var cliKeys = Object.keys(cat.clients).sort();
      var clis = cliKeys.map(function (cliKey) {
        var v = cat.clients[cliKey];
        return {
          client: cliKey,
          facturado: v.facturado,
          freight: v.freight,
          facturaCarrier: v.facturaCarrier,
          subsidyDiff: v.subsidyDiff,
          subCantidad: v.subCantidad,
          subPorcentaje: v.subPorcentaje
        };
      });
      return {
        lob: cKey,
        facturado: cat.totals.facturado,
        freight: cat.totals.freight,
        facturaCarrier: cat.facturaCarrier,
        subsidyDiff: cat.subsidyDiff,
        subCantidad: cat.subCantidad,
        subPorcentaje: cat.subPorcentaje,
        clients: clis,
      };
    });
    return {
      salesPerson: stKey,
      facturado: st.totals.facturado,
      freight: st.totals.freight,
      facturaCarrier: st.totals.facturaCarrier,
      subsidyDiff: st.totals.subsidyDiff,
      subCantidad: st.totals.subCantidad,
      subPorcentaje: st.totals.subPorcentaje,
      categories: cats,
    };
  });

  // Totales tfoot
  var total = result.reduce(function (acc, s) {
    acc.facturado += s.facturado;
    acc.freight += s.freight;
    acc.facturaCarrier += s.facturaCarrier;
    acc.subsidyDiff += s.subsidyDiff;
    acc.diffAgg += s.facturaCarrier;
    acc.diffCount += 1;
    acc.subCantidad += s.subCantidad;
    acc.subPorcentaje += s.subPorcentaje;
    return acc;
  }, { facturado: 0, freight: 0, subsidyDiff: 0, facturaCarrier: 0, diffAgg: 0, diffCount: 0, subCantidad: 0, subPorcentaje: 0});

  var totalRow = {
    facturado: total.facturado,
    freight: total.freight,
    facturaCarrier: total.facturaCarrier,
    subsidyDiff: total.subsidyDiff,
    subCantidad: total.subCantidad,
    subPorcentaje: total.subPorcentaje,
  };

  return { list: result, total: totalRow };
}

export default function SalesPersonStateTable(props) {
  var rows = props && props.rows ? props.rows : [];
  // var onExport = props && props.onExport ? props.onExport : function () {};
  var _useState = useState({}), openStates = _useState[0], setOpenStates = _useState[1];
  var _useState2 = useState({}), openCats = _useState2[0], setOpenCats = _useState2[1];

  var data = useMemo(function () { return buildHierarchy(rows); }, [rows]);

  function toggleState(st) {
    var next = {};
    for (var k in openStates) { if (Object.prototype.hasOwnProperty.call(openStates, k)) next[k] = openStates[k]; }
    next[st] = !next[st];
    setOpenStates(next);
  }
  function toggleCat(st, lob) {
    var key = st + "|" + lob;
    var next = {};
    for (var k in openCats) { if (Object.prototype.hasOwnProperty.call(openCats, k)) next[k] = openCats[k]; }
    next[key] = !next[key];
    setOpenCats(next);
  }

  return (
    <div className="card glass-card table-card w-100 bg-light">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fw-bold darkerPurpleText">By salesperson</h6>
        {/* <button className="btn btn-sm bg-light text-primary" onClick={onExport}>Export CSV</button> */}
      </div>

      <div className="table-responsive">
        <table className="table table-sm table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>Sales Person</th>
              {/* <th className="text-center">Facturado MYLND</th> */}
              <th className="text-center">Flete Cobrado</th>
              <th className="text-center">Factura Carrier</th>
              <th className="text-center">Subsidio</th>
              <th className="text-center">Subsidio</th>
            </tr>
          </thead>
          <tbody>
            {data.list.map(function (s) {
              var stOpen = !!openStates[s.salesPerson];
              return (
                <React.Fragment key={s.salesPerson}>
                  {/* Estado */}
                  <tr className="salesPerson-row" onClick={function () { return toggleState(s.salesPerson); }} role="button">
                    <td className="fw-semibold">
                      <span className={"chev " + (stOpen ? "rotate" : "")}>▶</span>
                      <span className="ms-2">{s.salesPerson}</span>
                    </td>
                    {/* <td className="text-center">{s.facturado}</td> */}
                    <td className="text-center">{fmtUSD(s.freight)}</td>
                    <td className="text-center">{fmtUSD(s.facturaCarrier)}</td>
                    <td className="text-center text-danger">- {fmtUSD(s.subsidyDiff)}</td>
                    <td className="text-center text-danger">- { ((s.subsidyDiff / s.facturaCarrier) * 100).toFixed(2) }%</td>
                  </tr>

                  {/* Categorías */}
                  {stOpen && s.categories.map(function (c) {
                    var key = s.salesPerson + "|" + c.lob;
                    var catOpen = !!openCats[key];
                    return (
                      <React.Fragment key={key}>
                        <tr className="cat-row" onClick={function () { return toggleCat(s.salesPerson, c.lob); }} role="button">
                          <td className="indent-1">
                            <span className={"chev " + (catOpen ? "rotate" : "")}>▶</span>
                            <span className="ms-2">{c.lob}</span>
                          </td>
                          {/* <td className="text-center">{c.facturado}</td> */}
                          <td className="text-center">{fmtUSD(c.freight)}</td>
                          <td className="text-center">{fmtUSD(c.facturaCarrier)}</td>
                          <td className="text-center">- {fmtUSD(c.subsidyDiff)}</td>
                          <td className="text-center">{ ((c.subsidyDiff / c.facturaCarrier) * 100).toFixed(2) }%</td>
                        </tr>

                        {/* Clientes */}
                        {catOpen && c.clients.map(function (cli) {
                          return (
                            <tr className="client-row" key={s.salesPerson + "|" + c.lob + "|" + cli.client}>
                              <td className="indent-2">{cli.client}</td>
                              {/* <td className="text-center">{cli.facturado}</td> */}
                              <td className="text-center">{fmtUSD(cli.freight)}</td>
                              <td className="text-center">{fmtUSD(cli.facturaCarrier)}</td>
                              <td className="text-center">- {fmtUSD(cli.subsidyDiff)}</td>
                              <td className="text-center">{ ((cli.subsidyDiff / cli.facturaCarrier) * 100).toFixed(2) }%</td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="table-total">
              <td>Total</td>
              {/* <td className="text-center">{data.total.facturado}</td> */}
              <td className="text-center">{fmtUSD(data.total.freight)}</td>
              <td className="text-center">{fmtUSD(data.total.facturaCarrier)}</td>
              <td className="text-center text-danger">- {fmtUSD(data.total.subsidyDiff)}</td>
              <td className="text-center text-danger">- { ((data.total.subsidyDiff / data.total.facturaCarrier) * 100).toFixed(2) }%</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
